import {Deserializable} from "../shared/models/deserializable.model";

export class Business implements Deserializable {
   accountId: number;
   id: number;
   name: string;
   createdAt: string;
   updatedAt: string;
   address1: string;
   address2: string;
   city: string;
   postcode: string;
   email: string;
   phone: string;
   website: string;
   logo_url: string;
   invoice_pre: string;
   invoice_post: string;
   invoice_next: string;
   invoice_email: string;
   invoice_footer: string;
   quote_pre: string;
   quote_post: string;
   quote_next: string;
   quote_email: string;
   quote_label: string;
   quote_footer: string;
   quote_hasPaymentDetails: boolean;
   invoice_description_position: string;
   quote_description_position: string;
   logo_position: 'LEFT' | 'RIGHT' | 'CENTER' | 'BANNER';
   logo_height: number;
   hasTax: boolean
   taxRate: string;
   taxName: string;
   taxNumber: string;
   templateId: number; // We need to have invoiceTemplateId and quoteTemplateId
   logoId: number;
   Logo: any;

   deserialize(input: any) {
   	Object.assign(this, input);
      return this;
   }

}

// Business settings
// Business - name, address1, address2, city, postcode, email, phone, website, logoURL
// Templates (for whole application that Business has 1)
// Invoice Settings - invoice_pre, invoice_post, invoice_count, invoice_footer, invoice_email
// Quote Settings - quote_pre, quote_post, quote_count, quote_footer, quote_email, hasPaymentDetails, quote_label
// Tax Settings - hasVat, vat_rate

// Create business [skip]
// Add details [skip]
// Add logo [skip]
// Quoting - choose template, settings [skip]
// Invoicing - choose template, settings [skip]

// Business view
// Business name with options: Business details, Tax settings, Payment details, Quote settings, Invoice settings

// Payment details
// + new payment details - bank transfer, card payment (stripe) belongsTo business